export function getFileNameFromHeader(response: Response): string {
  const header = response.headers.get("Content-Disposition") || "";

  const matches = /filename="([^"]+)/.exec(header);
  if (matches && matches[1]) {
    return matches[1];
  }
  return "taskmap.zip";
}
